export enum AppointmentTab {
    UPCOMING = 0,
    PREVIOUS = 1,
}
